<template>
  <footer id="contato"class="main-footer" :style="{backgroundColor: footerData.bgColor}">
    <div class="footer-container">
      <div class="footer-brand">
        <div class="footer-logo">
          <img :src="footerData.image.url" alt="FÁBIO PEREIRA" class="logo-img">
        </div>
        <p class="brand-description" v-html="footerData.description"></p>
      </div>

      <div class="footer-links">
        <h4>Navegação</h4>
        <ul>
          <li><a href="#home">Home</a></li>
          <li><a href="#ebooks">Livros</a></li>
          <li><a href="#information">Sobre</a></li>
        </ul>
      </div>
      <div class="footer-social">
        <h4>Siga-nos</h4>
        <div class="social-icons">
          <template v-for="social in socialList" :key="social.id">
            <a 
              v-if="social.isVisible" 
              :href="social.url" 
              target="_blank" 
              class="social-link" 
              :title="social.name"
            >
              <svg viewBox="0 0 24 24" class="icon-svg">
                <g v-html="iconMap[social.name.toLowerCase()]"></g>
              </svg>
              <span class="capitalize">{{ social.name }}</span>
            </a>
          </template>
        </div>
      </div>
        <div class="footer-copy">
          <p> &copy; {{ new Date().getFullYear() }} <strong>Fábio Pereira</strong> 
          - Neuropsiconutrição e Nutrição.  - <small>Todos os direitos reservados. CRN-10: 9477</small>
        </p>
      </div>
    </div>
    </footer>
</template>

<script setup lang="ts">
    // Você pode adicionar links reais aqui depois
    import { ref, onMounted } from 'vue';
    import { toRaw } from 'vue';

    const endpoint = process.env.VUE_APP_HYGRAPH_URL;
    
    const currentYear = new Date().getFullYear();

    // Mapeamento dos SVGs para cada rede (use os nomes que definiu no SELECT do ADM)
    const iconMap: Record<string, string> = {
      instagram: '<path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4H7.6m4.4 3.5a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 2a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5m4.5-1.25a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5Z"/>',
      facebook: '<path fill="currentColor" d="M12 2.04c-5.5 0-10 4.49-10 10.02c0 5 3.66 9.15 8.44 9.9v-7h-2.54v-2.9h2.54V9.82c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02Z"/>',
      youtube: '<path fill="currentColor" d="m10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73Z"/>',
      whatsapp: '<path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.188 8.188 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.68 4.25 3.75c.59.26 1.05.41 1.41.52c.6.19 1.14.16 1.57.1c.48-.07 1.47-.6 1.67-1.18s.2-1.07.14-1.18c-.06-.1-.22-.16-.48-.29c-.25-.13-1.47-.72-1.7-.8c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.26-.13-1.08-.4-2.06-1.27c-.76-.68-1.27-1.52-1.42-1.77c-.14-.25-.02-.39.11-.52c.11-.11.26-.3.39-.45c.13-.15.17-.25.26-.43c.09-.17.04-.32-.02-.45c-.06-.13-.56-1.35-.77-1.85c-.2-.5-.4-.43-.56-.43"/>',
      linkedin: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77Z"/>',
      tiktok: '<path fill="currentColor" d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.07v12.47c.18 1.96-1.57 3.56-3.5 3.5c-1.93-.06-3.5-1.53-3.5-3.5c0-1.97 1.57-3.5 3.5-3.5c.1 0 .21.01.31.02V8.91a7.1 7.1 0 0 0-3.81 1.05a6.43 6.43 0 0 0-3.47 5.54c0 3.59 2.91 6.5 6.5 6.5c3.59 0 6.5-2.91 6.5-6.5V9.41a6.3 6.3 0 0 0 4.14 1.41v-3s-1-.04-2.51-.77a4.65 4.65 0 0 1-1.51-1.23Z"/>',
      twitter: '<path fill="currentColor" d="M18.2 3H21l-6.1 7l7.1 9.4h-5.6l-4.4-5.8l-5 5.8H4.2l6.5-7.4l-6.7-8.9h5.7l4 5.3l4.5-5.3m-1 14.7h1.5L8 4.7H6.4l10.8 13Z"/>', // Versão atualizada (X)
      threads: '<path fill="currentColor" d="M15.42 13.39c-.58 0-1.02-.34-1.12-.86a1.76 1.76 0 0 1-.03-.31c0-.8.61-1.41 1.42-1.41c.4 0 .74.15.96.42c.19.23.27.52.27.85c0 .76-.66 1.31-1.5 1.31m6.08-1.12c0-3.32-1.26-5.83-3.75-7.46c-1.89-1.24-4.24-1.81-6.73-1.81c-2.43 0-4.63.5-6.42 1.49C2.47 5.62 1.33 7.39.75 9.59c-.56 2.1-.5 4.34.18 6.32c.69 2.01 2.05 3.73 3.82 4.84c1.8 1.13 4.13 1.75 6.7 1.75c2.42 0 4.54-.53 6.32-1.58c.4-.23.53-.75.3-1.15c-.23-.4-.74-.53-1.15-.3c-1.47.88-3.29 1.33-5.47 1.33c-2.22 0-4.22-.54-5.78-1.51c-1.51-.95-2.65-2.41-3.23-4.11c-.59-1.7-.63-3.64-.13-5.51c.51-1.92 1.51-3.48 2.97-4.63c1.55-.86 3.44-1.29 5.63-1.29c2.14 0 4.14.49 5.77 1.56c2.14 1.4 3.2 3.51 3.2 6.42c0 2.99-1.6 5.09-3.9 5.09c-1.15 0-2.11-.64-2.56-1.72c-.17-.37-.5-.65-.89-.78l-.34-.1c-.02-.01-.03-.01-.05-.01c-.24-.04-.49-.03-.73.04c-.37.1-.68.32-.86.63c-.15.25-.21.54-.2.83a2.6 2.6 0 0 0 .1 1.05c.34.92 1.1 1.58 2.11 1.83c.3.07.61.11.92.11c2.19 0 3.75-1.57 3.75-3.8c0-.02 0-.05-.01-.07c1.36-.61 2.21-1.72 2.21-3.27"/>'
    };

    const footerData = ref({
      description: '',
      image: { 
        url: '' 
      },
      bgColor: { 
        hex: '#111111' 
      }
    });

    const socialList = ref([]);

    const fetchData = async () => {
      // Ajuste o nome da query para bater com o seu modelo no Hygraph
      const query = `{
        footers {
          id
          description
          image { url}
          bgColor {hex}
        } 
        socialNetworks { 
          id 
          name 
          url 
          isVisible 
        } 
      }`;

      try 
      {
        const res = await fetch(`${endpoint}?t=${Date.now()}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query })
        });
        const request = await res.json();

        if (request.data) 
        { 
          if (request.data.footers.length > 0) {
            footerData.value = request.data.footers[0];
          }
      
          socialList.value = request.data.socialNetworks;          
        }
      } catch (error) {
        console.error("Erro ao carregar", error);
      }
    };
    onMounted(fetchData);
</script>



<style scoped>

  .social-icons {
    display: flex;
    flex-direction: row;
    gap: 15px;
  }

  .social-link {
    display: flex;
    align-items: center;
    gap: 10px; /* Espaço entre ícone e texto */
    color: #999;
    text-decoration: none;
    transition: 0.3s;
  }

  .social-link:hover {
    color: #439687; /* Verde da marca */
  }

  .icon-svg {
    width: 24px;
    height: 24px;
  }

  .footer-logo .logo-img {
    height: 80px;
    /* Se a sua logo original for escura, o filtro abaixo a deixa branca para o fundo preto */
    /*filter: brightness(0) invert(1);*/
  }

  .main-footer {
    background-color: #111; /* Preto profundo para combinar com o Header */
    color: #fff;
    padding: 60px 20px 20px;
    margin-top: 40px;
  }

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 40px;
  }



  .logo-text {
    display: flex;
    flex-direction: column;
  }

  .logo-text .name {
    color: #439687; /* Verde da marca */
    font-weight: 800;
    font-size: 1.1rem;
  }

  .logo-text .sub {
    font-size: 0.7rem;
    color: #999;
    letter-spacing: 2px;
  }

  .brand-description {
    color: #999;
    font-size: 0.9rem;
    line-height: 1.6;
    max-width: 300px;
  }

  h4 {
    color: #fff;
    margin-bottom: 20px;
    font-size: 1.1rem;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  ul li {
    margin-bottom: 10px;
  }

  ul li a {
    color: #999;
    text-decoration: none;
    transition: color 0.3s;
  }

  ul li a:hover {
    color: #439687;
  }



  .footer-bottom {
    margin-top: 60px;
    padding-top: 20px;
    border-top: 1px solid #222;
    text-align: center;
    color: #666;
    font-size: 0.8rem;
  }

.footer-copy {
  grid-column: 1 / span 3; /* Faz a div ocupar as 3 colunas */
  text-align: center;      /* Centraliza o texto dentro dela */
  margin-top: 20px;        /* Espaçamento opcional para desgrudar de cima */
  width: 100%;             /* Garante que ela use todo o espaço disponível */
}

  @media (max-width: 768px) {
    .footer-container {
      grid-template-columns: 1fr;
      text-align: center;
    }
    .footer-logo {
      justify-content: center;
    }
    .brand-description {
      margin: 0 auto;
    }
  }
  @media (max-width: 1024px) {
  .footer-container {
    /* Em tablets, diminuímos para 2 colunas para não espremer o texto */
    grid-template-columns: 1fr 1fr; 
    gap: 30px;
  }

  .footer-logo {
    grid-column: 1 / span 2; /* Logo e descrição ocupam o topo todo */
    text-align: center;
  }

  .brand-description {
    max-width: 100%; /* Permite que o texto flua melhor */
  }
}

@media (max-width: 768px) {
  .main-footer {
    padding: 40px 15px 20px; /* Reduz o respiro lateral no celular */
  }

  .footer-container {
    /* No celular vira uma coluna única */
    grid-template-columns: 1fr; 
    text-align: center;
    gap: 40px;
  }

  .footer-logo {
    grid-column: 1;
  }

  .social-icons {
    justify-content: center; /* Centraliza o ícone do Instagram no mobile */
  }

  .brand-description {
    margin: 0 auto; /* Centraliza o bloco de texto */
  }

  .footer-copy {
    grid-column: 1; /* Volta para a primeira e única coluna */
    font-size: 0.75rem; /* Diminui um pouco a letra para não quebrar tantas linhas */
    line-height: 1.5;
    padding: 0 10px;
  }
  
  /* Ajuste para o logo não ficar gigante no celular */
  .footer-logo .logo-img {
    height: 60px;
    margin-bottom: 15px;
  }
}
</style>